<form class="grid-container" [formGroup]="formGroup">
  <div class="grid-x grid-margin-x">
    <div class="cell large-12 medium-12 small-12 bold">
      Enter Search Criteria:
    </div>

    <div class="cell large-2 medium-3 small-12 bold">
      Document Group:
    </div>
    <div class="cell large-10 medium-9 small-12">
      <text-loader [run]="documentGroups == null" [text]="'Loading Document Groups'" [tickType]="'.'" [interval]="1500"></text-loader>
      @if (documentGroups != null) {
        <ng-select formControlName="documentGroup" [items]="documentGroups" bindValue="id" bindLabel="name" [placeholder]="" (ngModelChange)="documentGroupChanged($event)"></ng-select>
      }
    </div>
    <div class="cell large-2 medium-3 small-12 bold">
      Document Type:&nbsp;<help-text [helpText]="documentTypeInfoBubble"></help-text>
    </div>
    <div class="cell large-8 medium-5 small-8">
      <text-loader [run]="documentTypes == null" [text]="'Loading Document Types'" [tickType]="'.'" [interval]="1500"></text-loader>
      @if (documentTypes != null) {
        <ng-select formControlName="documentType" [items]="documentTypes" bindValue="id" bindLabel="name" [placeholder]="" (ngModelChange)="documentTypeChanged($event)"></ng-select>
      }
    </div>
    <div class="cell large-2 medium-4 small-4 padding-left text-align-right">
      <span class="padding-right">
        <button class="button" [disabled]="formGroup?.get('documentType')?.invalid" (click)="addDocumentType()">Add</button>
      </span>
      <span>
        <button class="button" [disabled]="formGroup.get('documentGroup')?.value === selectDocumentGroup.id || documentTypes == null" (click)="addAllTypes()">Add All</button>
      </span>
    </div>
  </div>
  <div class="grid-x grid-margin-x" formGroupName="keywordCriteria">
    <div class="cell large-12 medium-12 small-12">
      <span class="bold padding-right">Available Keywords:</span><span class="margin-left"><help-text [helpText]="helpText"></help-text></span>
    </div>
    <div class="cell large-5 medium-5 small-5">
      <text-loader [run]="availableKeywords == null" [text]="'Loading Available Keywords'" [tickType]="'.'" [interval]="1500"></text-loader>
      @if (availableKeywords != null) {
        <ng-select formControlName="selectedKeyword" [items]="availableKeywords" bindValue="id" bindLabel="name" [placeholder]=""></ng-select>
      }
    </div>
    <div class="cell large-1 medium-1 small-1">
      <select id="equality" formControlName="equality" class="equality-select">
        @for (option of equalityOptions; track option) {
          <option [ngValue]="option.id">{{option.text}}</option>
        }
      </select>
    </div>
    <div class="cell large-5 medium-4 small-4">
      <input type="text" formControlName="keywordValue" />
    </div>
    <div class="cell large-1 medium-2 small-2 padding-left">
      <button class="button" [disabled]="formGroup?.get('keywordCriteria')?.invalid" (click)="addKeywordCriteria()">Add</button>
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell large-3 medium-3 small-3 text-align-right bold">
      From Date:
    </div>
    <div class="cell large-2 medium-2 small-2">
      <common-date-picker [id]="'fromDate'" [initialDate]="fromDate" (dateUpdated)="fromDateChanged($event)"></common-date-picker>
    </div>
    <div class="cell large-3 medium-3 small-3 text-align-right bold">
      To Date:
    </div>
    <div class="cell large-2 medium-2 small-2">
      <common-date-picker [id]="'toDate'" [initialDate]="toDate" (dateUpdated)="toDateChanged($event)"></common-date-picker>
    </div>
    <div class="cell large-2 medium-2 small-2">
      &nbsp;
    </div>
  </div>
  <div class="grid-x grid-margin-x">
    <div class="cell large-12 medium-12 small-12 bold">
      Selected Document Types:
    </div>
    @for (type of selectedDocumentTypes; track type) {
      <div class="cell large-6 medium-6 small-12 padding-all-small">
        <span class="selection padding-all-small shrink-font">
          {{ type.name }}
          <button (click)="removeDocumentType(type.id)">
            <svg-icon icon="icon-trash" class="small black"></svg-icon>
          </button>
        </span>
      </div>
    }

  </div>
  @if (requiredKeywords?.length > 0) {
    <div class="grid-x grid-margin-x margin-bottom">
      <div class="cell large-12 medium-12 small-12">
        <span class="bold red padding-right">Required Keywords:</span><span class="margin-left"><help-text [helpText]="requiredWarning"></help-text></span>
      </div>
      @for (word of requiredKeywords; track word) {
        <div class="cell large-6 medium-6 small-6">
          <span class="selection-required padding-all-small shrink-font">
            {{word.toString()}}
          </span>
        </div>
      }
    </div>
  }
  <div class="grid-x grid-margin-x margin-bottom">
    <div class="cell large-12 medium-12 small-12 bold">
      Selected Keywords:
    </div>
    @for (word of selectedKeywords; track word) {
      <div class="cell large-6 medium-6 small-6">
        <span class="selection padding-all-small shrink-font">
          {{word.toString()}}
          <button (click)="removeKeywordCriteria(word)">
            <svg-icon icon="icon-trash" class="small black"></svg-icon>
          </button>
        </span>
      </div>
    }
  </div>
  <div class="grid-x grid-margin-x margin-top">
    <div class="cell large-12 medium-12 small-12 text-align-left">
      <button class="button" (click)="search()" [disabled]="disableSearch">Search For Documents</button>
    </div>
  </div>
</form>